// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_9q44K leading-[1.4] text-[0.9rem] font-semibold font-openSans sm_text-[20px] sm_font-normal lg_w-full lg_text-[21.6px]"};